import fetch from 'cross-fetch'

const SUCCESSFUL_RESPONSE = 1;
const REGISTER_NEWSLETTER_ENDPOINT = '/v3/newsletter/subscription';

const post = (path, data) => {
  let fetchSettings = {
    method: 'POST',
    body: data
  }

  return fetch(path, fetchSettings)
  .then(handleErrors)
  .then(response => response.json())
  .catch(console.error)
}

const handleErrors = (response) => {
  if (!response.ok) throw Error(response.statusText)
  return response
}

const registerEmail = (data = {}, onSuccess, onError, onFinished) => {
  let formData = new FormData();
  formData.append('frequency', 'daily');

  for (const key in data) {
    formData.append(key, data[key]);
  }

  post(REGISTER_NEWSLETTER_ENDPOINT, formData)
  .then(response => {
    if (response && response.status === SUCCESSFUL_RESPONSE) {
      onSuccess({
        success: true,
        message: 'Frequency successfully updated!',
      }, response.signedParams);
    } else {
      onError({
        success: false,
        message: "An error occurred. Please try again later.",
      });
    }
    onFinished();
  })
}

export {registerEmail}
